import {
  FormValidator,
  type FormValidatorConfig,
  type FormValidatorSettings,
  isEmpty,
  type FormValidatorContext
} from '@common';
import { LayerGroupKind } from '../../geo-layers-upload/enums';

export type YieldZoneLevelSettings = FormValidatorSettings;

export type YieldZoneLevelConfig = FormValidatorConfig<YieldZoneLevelSettings>;

export class YieldZoneLevelValidator extends FormValidator<YieldZoneLevelSettings> {
  constructor() {
    super();
    this._name = 'yieldZoneLevel';
    this._settings = {
      invalidMessage: 'yieldZoneLevel.validator.invalidMessage',
      needTranslate: true
    };
  }

  public override async onValidate(value: any, context: FormValidatorContext) {
    if (isEmpty(value) || !context.element.enabled) {
      return;
    }

    if (value.layerGroupKind === LayerGroupKind.VANTAGE_YIELD) {
      this.addMessage(this._settings.invalidMessage, 'warning', { yieldAmount: value.yieldAmount });
    }

    //todo applied dose after creating work type

    this.valid = true;
  }
}
